export default __webpack_public_path__ + "static/media/reaction-02.62e5e7d8.svg";